export default "/fonts/vendor/boxicons/boxicons.woff?1a7e2e2bf3a855e674d494676f7ca508";